import { AbstractControl } from '@angular/forms';
import { calculateAge, dobRegex } from './util';

export default function atMostAge(maxAge) {
  return (control: AbstractControl) => {
    if (control && control.value) {
      if (dobRegex.test(control.value)) {
        const calcAge = calculateAge(control.value);
        if (calcAge >= maxAge) {
          return {
            atMostAge: true,
          };
        }
      }
    }
    return null;
  };
}
